import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'app/utility/loader/loader.service';
import { SKIP_LOADER } from './tokens/skip-loader.token';


@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoader = req.context.get(SKIP_LOADER);
     console.log('SKIP LOADER VALUE:', skipLoader);
    if (!skipLoader) {
      this.loaderService.show();
    }
    return next.handle(req).pipe(
      finalize(() => {
        if (!skipLoader) {
          this.loaderService.hide();
        }
      })
    );
  }
}
